var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
define(["require", "exports", "jquery", "i18n-ts", "QuantaNumber"], function (require, exports, jquery_1, i18n, QuantaNumber) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.renderLike = exports.generateHtmlTitleWithInfoBulle = exports.renderSRRInoScale = exports.renderESG_Gouvernance = exports.renderESG_Social = exports.renderESG_Environnement = exports.renderIntensiteESG = exports.renderIntensiteISR = exports.renderIndicateurISR = exports.renderAlertsForPort = exports.renderAlertsForList = exports.renderScore = exports.renderTrueOrEmpty = exports.renderBoolColored = exports.renderEnveloppeString = exports.renderEnveloppe = exports.renderModeGestion = exports.renderProfil = exports.renderChip = exports.renderActif = exports.renderCoupon = exports.renderPerteMax100 = exports.renderPerteMax = exports.renderValue = exports.renderMontant = exports.makeRenderMontantFormated = exports.renderVL = exports.renderFraisES = exports.createdCellReturn = exports.outputStopSign = exports.renderSRRILight = exports.renderSRRI = exports.checkbox = exports.renderNotation = exports.renderBool = exports.renderNomNoBlank = exports.renderNom = exports.outputFinancialItemName = exports.renderColor = exports.RenderLocaleDate = exports.RenderDate = exports.renderImgPDF = exports.renderPDF = exports.renderReturn100 = exports.renderTooltips = exports.renderString = exports.renderReturnM = exports.renderReturn = exports.renderVLWithCheck = exports.renderRatio = exports.renderDelete = void 0;
    jquery_1 = __importDefault(jquery_1);
    i18n = __importStar(i18n);
    QuantaNumber = __importStar(QuantaNumber);
    /**
    * Number.prototype.format(n)
    * @param integer n: length of decimal
    */
    Number.prototype['format'] = function (n) {
        if (n == null)
            n = 0;
        return this.valueOf().toLocaleString('fr-FR', { maximumFractionDigits: n });
    };
    function renderDelete(data, type, row, meta) {
        return "<i class='glyphicon glyphicon-trash clickable'/>";
    }
    exports.renderDelete = renderDelete;
    ;
    //Trim à 2 chiffres après la virgule
    function renderRatio(data, type, row, meta) {
        if (data == null || isNaN(data))
            return "-";
        return data.toFixed(2);
    }
    exports.renderRatio = renderRatio;
    function renderVLWithCheck(data, type, row, meta) {
        if (row.sTypeFinancialObject == "SE")
            return "- -";
        return renderRatio(data, type, row, meta);
    }
    exports.renderVLWithCheck = renderVLWithCheck;
    //Trim à 2 chiffres après la virgule et ajoute %
    function renderReturn(data, type, row, meta) {
        if (data == null || isNaN(data))
            return "-";
        return data.toFixed(2) + " %";
    }
    exports.renderReturn = renderReturn;
    //Conversion en million, Trim à 2 chiffres après la virgule et ajoute M
    function renderReturnM(data, type, row, meta) {
        if (data == null || isNaN(data))
            return "-";
        var n = data / Math.pow(10, 6);
        var tab = String(n.toFixed(2)).split(".");
        tab[0] = String(tab[0]).replace(/(.)(?=(\d{3})+$)/g, '$1,');
        return tab.join(".") + "M";
    }
    exports.renderReturnM = renderReturnM;
    // Remplace les string vides par des "-"
    function renderString(data, type, row, meta) {
        if (!data)
            return "-";
        return data;
    }
    exports.renderString = renderString;
    ;
    // Retourne le nombre d'éléments contenus dans un string (séparateur = ','), le contenu sera un tooltip
    function renderTooltips(data, type, row, meta) {
        if (!data) {
            return "-";
        }
        var sTab = data = data.split(',');
        if (sTab.length === 1) {
            return data;
        }
        return '<span data-toggle="tooltip" title="' + sTab.join("<br/>") + '" data-placement="left" data-html="true">' + sTab.length + '</span>';
    }
    exports.renderTooltips = renderTooltips;
    //x100, Trim à 2 chiffres après la virgule et ajoute %
    function renderReturn100(data, type, row, meta) {
        if (data == null || isNaN(data))
            return "-";
        return (data * 100).toFixed(2) + " %";
    }
    exports.renderReturn100 = renderReturn100;
    function renderPDF(data, type, row, meta) {
        if (data == null || data === "")
            return "";
        if (row.isMainDocumentAccessible !== undefined && row.isMainDocumentAccessible == false)
            return "<span class='disabled'><i class='fa fa-file-pdf-o'></i></span>";
        return "<a href='" + data + "'><i class='fa fa-file-pdf-o'></i></a>";
    }
    exports.renderPDF = renderPDF;
    function renderImgPDF(data, type, row, meta) {
        if (data == null || data === "")
            return "";
        if (row.isMainDocumentAccessible !== undefined && row.isMainDocumentAccessible == false)
            return "<span class='disabled'><i class='fa fa-file-pdf fa-1-5x'><i/></span>";
        return "<a href='" + data + "'><i class='fa fa-file-pdf fa-1-5x text-danger'><i/></a>";
    }
    exports.renderImgPDF = renderImgPDF;
    // Deprecated : utiliser RenderLocalDate à la place
    // Format DD/MM/YY 
    function RenderDate(data, type, row, meta) {
        if (data === undefined)
            return "";
        //Equivaut au Date.MinValue de VB.Net
        if (data == "0001-01-01" || data === null) {
            return "-";
        }
        var dt = new Date(data);
        var nMonth = dt.getMonth() + 1;
        if (nMonth < 10)
            nMonth = "0".concat(nMonth.toString());
        var nDate = dt.getDate();
        if (nDate < 10)
            nDate = "0".concat(nDate.toString());
        return nDate + "/" + nMonth + "/" + dt.getFullYear().toString().substr(2, 2);
    }
    exports.RenderDate = RenderDate;
    //Format de la date en paramètre (facultatif)
    //voir https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toLocaleDateString
    function RenderLocaleDate(format) {
        return function (data, type, row, meta) {
            if (type === "sort")
                return data; //pas de transormation pour le sort
            if (data == null)
                return "";
            //Equivaut au Date.MinValue de VB.Net
            if (data == "0001-01-01")
                return "";
            var dt = new Date(data);
            return dt.toLocaleDateString(i18n.Culture(), format);
        };
    }
    exports.RenderLocaleDate = RenderLocaleDate;
    //Colonne couleur
    function renderColor(data, type, row, meta) {
        //return "<input type='text' class='colorPicker'/>";
        //return "<div class='colorPicker'></div>";
        return "";
    }
    exports.renderColor = renderColor;
    //Lien sur nom du financial item
    //Deprecated, utiliser renderNom
    function outputFinancialItemName(name, url, openNewTab) {
        if (name == null)
            name = "";
        if (openNewTab == null)
            openNewTab = true;
        var result = name;
        if (url != null && url !== "") {
            var targetBlank = "";
            if (openNewTab)
                targetBlank = "target='_blank'";
            result = "<a href='" + url + "' " + targetBlank + ">" + name + "</a>";
        }
        return result;
    }
    exports.outputFinancialItemName = outputFinancialItemName;
    function renderNom(data, type, row, meta) {
        if (row.sNom == null)
            row.sNom = "";
        var result = row.sNom;
        if (row.sURL != null && row.sURL !== "") {
            var style = "";
            //Si fermé ou pas assez d'histo, nom en gris
            var grayName = (row.bFerme != null && row.bFerme) || (row.bEnoughHisto != null && row.bEnoughHisto === false) || (row.bNonCommercialise != null && row.bNonCommercialise === true);
            if (grayName) {
                style = "style='color:#909090;'";
            }
            result = "<a href='" + row.sURL + "' target='_blank' " + style + " >" + row.sNom + "</a>";
        }
        return result;
    }
    exports.renderNom = renderNom;
    function renderNomNoBlank(data, type, row, meta) {
        var result = renderNom(data, type, row, meta);
        //remove target blank
        result = result.replace("target='_blank'", "");
        return result;
    }
    exports.renderNomNoBlank = renderNomNoBlank;
    //Boolean
    function renderBool(data, type, row, meta) {
        if (data) {
            return "<i class='glyphicon glyphicon-check' title='Oui' />";
        }
        else {
            return "<i class='glyphicon glyphicon-unchecked' title='Non' />";
        }
    }
    exports.renderBool = renderBool;
    //Etoiles quantalys
    function renderNotation(data, type, row, meta) {
        if (data == null || parseInt(data) == 0)
            return "-";
        return "<img src='/Areas/Shared/Static/img/notation/qt-star-" + data + "-5.png' alt='" + row.nScore + " / 100' style='width: 60px;'>";
    }
    exports.renderNotation = renderNotation;
    //Checkbox
    function checkbox(data, type, row, meta) {
        if (row != null && row.bIsVisible != null && !row.bIsVisible) {
            return "";
        }
        return '<label class="fancy-checkbox m-r-0"> <input type="checkbox" /> <span class="fancy-content"></span> </label>';
    }
    exports.checkbox = checkbox;
    function renderSRRI(data, type, row, meta) {
        if (data == null || data === 0)
            return "-";
        var result = "";
        for (var i = 1; i <= 7; i++) {
            var selectedClass = (data == i) ? ' indic-srri-selected' : '';
            result += '<div class="indic-srri indic-srri-small' + selectedClass + '">' + i + '</div>';
        }
        return result;
    }
    exports.renderSRRI = renderSRRI;
    function renderSRRILight(data, type, row, meta) {
        if (data == null || data === 0)
            return "";
        return '<div class="indic-srri-box-single indic-srri-default srri-border"><div class="indic-srri indic-srri-selected">' + data.toString() + '</div>';
    }
    exports.renderSRRILight = renderSRRILight;
    //Stop sign (à la place des cases à cocher dans comparaison)
    function outputStopSign() {
        return '<i class="no-checkbox fa fa-ban fa-ban-qt"></i>';
    }
    exports.outputStopSign = outputStopSign;
    //Color texte en vert/rouge
    function createdCellReturn(cell, cellData, rowData, rowIndex, colIndex) {
        if (cellData > 0) {
            (0, jquery_1.default)(cell).addClass("numPositif");
        }
        else if (cellData < 0) {
            (0, jquery_1.default)(cell).addClass("numNegatif");
        }
    }
    exports.createdCellReturn = createdCellReturn;
    function renderFraisES(data, type, row, meta) {
        if (row.bCourtage) {
            return "Courtage";
        }
        if (data == null || isNaN(data))
            return "-";
        return data.toFixed(2) + " %";
    }
    exports.renderFraisES = renderFraisES;
    //VL : 4 chiffres après la virgule
    //fonction modifiée car elle ne gère pas la culture et affiche autant de décimales que dans la donnée initiale putôt que de toujours afficher n chiffres.
    function renderVL(data, type, row, meta) {
        if (data == null || isNaN(data))
            return "-";
        return data.toLocaleString(i18n.Culture(), { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    exports.renderVL = renderVL;
    function makeRenderMontantFormated(format) {
        return function (data, type, row, meta) {
            if (type === "sort")
                return data; //pas de transormation pour le sort
            if (data == null || isNaN(data))
                return "-";
            return QuantaNumber.ToFormat(data, format) + " €";
        };
    }
    exports.makeRenderMontantFormated = makeRenderMontantFormated;
    exports.renderMontant = makeRenderMontantFormated({ maximumFractionDigits: 0 });
    function renderValue(data, type, row, meta) {
        if (data == null || isNaN(data))
            return "-";
        return QuantaNumber.ToFormat(data, { maximumFractionDigits: 2 });
    }
    exports.renderValue = renderValue;
    function renderPerteMax(data, type, row, meta) {
        if (data == null || isNaN(data))
            return "-";
        return QuantaNumber.ToFormat(data, { maximumFractionDigits: 2 }) + " %";
    }
    exports.renderPerteMax = renderPerteMax;
    function renderPerteMax100(data, type, row, meta) {
        if (data == null || isNaN(data))
            return "-";
        return QuantaNumber.ToFormat(data * 100, { maximumFractionDigits: 2 }) + " %";
    }
    exports.renderPerteMax100 = renderPerteMax100;
    //Coupon : 4 chiffres après la virgule
    function renderCoupon(data, type, row, meta) {
        if (data == null || isNaN(data))
            return "-";
        return data.toFixed(4);
    }
    exports.renderCoupon = renderCoupon;
    //Actifs : 4 chiffres après la virgule
    function renderActif(data, type, row, meta) {
        if (data == null || isNaN(data))
            return "-";
        return data.format(4).replace(".", ",");
    }
    exports.renderActif = renderActif;
    function renderChip(data, type, row, meta) {
        if (data == null)
            return '<span class="chip chip-bordered chip-unknown chip-small"></span>';
        else {
            switch (parseInt(data)) {
                case -3:
                    return '<span class="chip chip-bordered chip-unknown chip-small"></span>';
                case -2:
                    return '<span class="chip chip-bordered chip-unknown chip-small"></span>';
                case -1:
                    return '<span class="chip chip-bordered chip-danger chip-small"></span>';
                case 0:
                    return '<span class="chip chip-bordered chip-warning chip-small"></span>';
                case 1:
                    return '<span class="chip chip-bordered chip-success chip-small"></span>';
                default:
                    return '<span class="chip chip-bordered chip-unknown chip-small"></span>';
            }
        }
    }
    exports.renderChip = renderChip;
    function renderProfil(data, type, row, meta) {
        if (data == null)
            return 'Non défini';
        else {
            switch (data) {
                case 1:
                    return 'Prudent';
                case 2:
                    return 'Equilibre';
                case 3:
                    return 'Dynamique';
                case 4:
                    return 'PEA';
                default:
                    return 'Non défini';
            }
        }
    }
    exports.renderProfil = renderProfil;
    function renderModeGestion(data, type, row, meta) {
        if (data == null)
            return 'Non défini';
        else {
            switch (data) {
                case 1:
                    return 'Libre';
                case 2:
                    return 'Gestion conseillée';
                case 3:
                    return 'Cons. premium';
                case 4:
                    return 'Cons. banquier';
                case 5:
                    return 'Cons. divers.';
                case 6:
                    return 'Gérée';
                default:
                    return 'Non défini';
            }
        }
    }
    exports.renderModeGestion = renderModeGestion;
    function renderEnveloppe(data, type, row, meta) {
        if (data == null)
            return 'Non défini';
        switch (parseInt(data)) {
            case 1:
                return 'CT';
            case 2:
                return 'AV';
            case 3:
                return 'PEA';
            case 4:
                return 'PEA PME';
            case 5:
                return 'PEE';
            default:
                return 'Non défini';
        }
    }
    exports.renderEnveloppe = renderEnveloppe;
    function renderEnveloppeString(data, type, row, meta) {
        if (data == null)
            return 'Non défini';
        switch (data) {
            case 'CT':
            case 'AV':
            case 'PEA':
            case 'PEA_PME':
            case 'PEE':
                return data;
            default:
                return 'Non défini';
        }
    }
    exports.renderEnveloppeString = renderEnveloppeString;
    function renderBoolColored(data, type, row, meta) {
        if (data) {
            return "<i class='fa fa-check text-success' title='Oui' />";
        }
        else if (data == null) {
            return "-";
        }
        else if (!data) {
            return "<i class='fa fa-times text-danger' title='Non' />";
        }
    }
    exports.renderBoolColored = renderBoolColored;
    function renderTrueOrEmpty(data, type, row, meta) {
        if (data) {
            return "<i class='fa fa-check text-success' title='Oui' />";
        }
        else {
            return "-";
        }
    }
    exports.renderTrueOrEmpty = renderTrueOrEmpty;
    function renderScore(data, type, row, meta) {
        if (data == null || data === 0)
            return "-";
        var result = "<div style='width: max-content'>";
        for (var i = 1; i <= 5; i++) {
            var selectedClass = (data >= i) ? ' conseil-selected' : '';
            result += '<div class="conseil-default' + selectedClass + '">' + '</div>';
        }
        result += "</div>";
        return result;
    }
    exports.renderScore = renderScore;
    function renderAlertsForList(data, type, row, meta) {
        if (data == null || data === "" || data === "[]" || data === "null")
            return "-";
        data = JSON.parse(data);
        var out = "";
        if (data.state === "R") {
            out = '<a target="_blank" href="/Alert/Index/' + data.id_item + '/0/1"><i class="state-alert-in fas fa-exclamation-triangle"></i></a>';
        }
        else {
            out = '<a target="_blank" href="/Alert/Index/' + data.id_item + '/0/1"><i class="state-alert-out fas fa-exclamation-triangle"></i></a>';
        }
        return out;
    }
    exports.renderAlertsForList = renderAlertsForList;
    function renderAlertsForPort(data, type, row, meta) {
        if (data == null || data === "" || data === "[]" || data === "null")
            return "-";
        data = JSON.parse(data);
        var out = "";
        if (data.state === "R") {
            out = '<a target="_blank" href="/Alert/Index/' + data.id_item + '/1/0"><i class="state-alert-in fas fa-exclamation-triangle"></i></a>';
        }
        else {
            out = '<a target="_blank" href="/Alert/Index/' + data.id_item + '/1/0"><i class="state-alert-out fas fa-exclamation-triangle"></i></a>';
        }
        return out;
    }
    exports.renderAlertsForPort = renderAlertsForPort;
    function renderIndicateurISR(data, type, row, meta) {
        if (data == null || parseInt(data) == 0)
            return "-";
        var out = "";
        for (var i = 1; i < 6; i++) {
            if (i <= data) {
                out += '<div class="conseil-default conseil-green conseil-selected"></div>';
            }
            else {
                out += '<div class="conseil-default"></div>';
            }
        }
        return out;
    }
    exports.renderIndicateurISR = renderIndicateurISR;
    function renderIntensiteISR(data, type, row, meta) {
        if (data == null || parseInt(data) == 0)
            return "-";
        var out = "";
        for (var i = 1; i < 4; i++) {
            if (i <= data) {
                out += "<img src=\"/Areas/Shared/Static/img/esg/Matrice/Case_vert_".concat(i, ".svg\" alt=\"").concat(data, "/3\" style=\"height: 18px;\">");
            }
            else {
                out += "<img src=\"/Areas/Shared/Static/img/esg/Matrice/Case_vide.svg\" alt=\"".concat(data, "/3\" style=\"height: 18px;\">");
            }
        }
        return out;
    }
    exports.renderIntensiteISR = renderIntensiteISR;
    function renderIntensiteESG(data, type, row, meta) {
        if (data == null || parseInt(data) == 0)
            return "<i class='fa fa-times text-danger' title='Non' />";
        return "<img src=\"/Areas/Shared/Static/img/esg/Scale/esg_scale_".concat(data, ".svg\" alt=\"").concat(data, "/3\" style=\"height: 18px;\">");
    }
    exports.renderIntensiteESG = renderIntensiteESG;
    function renderESG_Environnement(data, type, row, meta) {
        if (data == null || isNaN(data))
            return "-";
        var out = "<img src=\"/Areas/Shared/Static/img/esg/Environnement/Environnement_".concat(data, ".svg\" alt=\"").concat(data, "/3\" style=\"height: 18px;\">");
        return out;
    }
    exports.renderESG_Environnement = renderESG_Environnement;
    function renderESG_Social(data, type, row, meta) {
        if (data == null || isNaN(data))
            return "-";
        var out = "<img src=\"/Areas/Shared/Static/img/esg/Social/Social_".concat(data, ".svg\" alt=\"").concat(data, "/3\" style=\"height: 18px;\">");
        return out;
    }
    exports.renderESG_Social = renderESG_Social;
    function renderESG_Gouvernance(data, type, row, meta) {
        if (data == null || isNaN(data))
            return "-";
        var out = "<img src=\"/Areas/Shared/Static/img/esg/Gouvernance/Gouvernance_".concat(data, ".svg\" alt=\"").concat(data, "/3\" style=\"height: 18px;\">");
        return out;
    }
    exports.renderESG_Gouvernance = renderESG_Gouvernance;
    function renderSRRInoScale(data, type, row, meta) {
        if (data == null)
            return "-";
        return data + "/7";
    }
    exports.renderSRRInoScale = renderSRRInoScale;
    function generateHtmlTitleWithInfoBulle(title, infoBulleText, iconClass) {
        if (iconClass === void 0) { iconClass = "fa fa-question-circle"; }
        var icon = "<br/><i _style_ class='" + iconClass + "' ></i>";
        if (!title) {
            icon = icon.replace('_style_', "style='position:absolute;z-index:1000;left:2px;top:25px'");
        }
        icon = icon.replace('_style_', '');
        var html = "<div  style='z-index:1000;text-align:center' title = \"_infoBulleText_\" data-trigger=\"hover\" data-tooltip-isinit=\"true\" data-toggle=\"tooltip\" data-html=\"true\" data-html=\"true\" >" + title + "_icon_ </div>";
        return html.replace("_infoBulleText_", infoBulleText).replace('_icon_', icon);
    }
    exports.generateHtmlTitleWithInfoBulle = generateHtmlTitleWithInfoBulle;
    function renderLike(data, type, row, meta) {
        if (row.bFavoris == null)
            row.bFavoris = false;
        var result = "";
        if (row.ID_Produit > 0) {
            result = "<span name='btn-like' class='btn-like glyphicon " + (row.bFavoris ? 'glyphicon-heart' : 'glyphicon-heart-empty') + "' data-produit='" + row.sNom + "' data-checked='" + row.bFavoris + "' data-id='" + row.ID_Produit + "'> </span>";
        }
        return result;
    }
    exports.renderLike = renderLike;
});
//# sourceMappingURL=datatables.render.methods.js.map